/*
 * File: Register.tsx
 * Project: a-a
 * File Created: Thursday, 10th October 2024 8:25:30 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 11:26:48 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */

import React, { useState } from 'react';
import styles from './Register.module.css';
import CustomButton from '../../components/shared/CustomButton/CustomButton';
import zeplinColor from '../../theme/Color';
import CustomTextField from '../../components/shared/CustomTextField/CustomTextField';
import RoutePaths from '../../routes/RoutePaths';
import EntryLayoutScreen from '../../components/shared/EntryLayout/EntryLayout';
import { AuthService } from '../../service/auth.service';
import { Link, useNavigate } from 'react-router-dom';
// import { validateEmail } from '../../helper/validate';
import { useInput } from '../../customHook/useInput';
import validator from 'validator';

const RegisterScreen = () => {
  const navigate = useNavigate();
  const {
    handleChange,
    handleBlur,
    value: email,
    error,
    setError,
    invalid,
    didChange,
  } = useInput('', validator.isEmail);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  sessionStorage.setItem('register-user', '');
  const validateUser = async () => {
    try {
      handleOpen();
      const res = await AuthService.validateUser(email);

      if (res.includes('already')) {
        setError('User exist already');
      } else {
        sessionStorage.setItem('register-user', res.split(' ')[1]);
        navigate('/new-user');
      }
    } catch (err: any) {
      setError(
        err?.response?.data?.name
          .split(/(?=[A-Z])/)
          .splice(0, 2)
          .join(' '),
      );
    } finally {
      // Hide loading indicator
      handleClose();
    }
  };

  // const [email,setEmail]=useState('')
  // const [error,setError]=useState('')
  // const valid=didChange && validateEmail(email)
  // const handleBlur=()=>{
  //     setDidChange(true)
  // }
  // const handleChange=(event:React.ChangeEvent<HTMLInputElement>)=>{
  //     setError('')
  //     setDidChange(false)
  //     setEmail(event.target.value)
  // }

  const children = (
    <div className={styles['register-input']}>
      <CustomTextField
        onChange={handleChange}
        style={{ width: '50%' }}
        onBlur={handleBlur}
        name='email'
        text={email}
        error={error ? error : invalid && didChange ? 'Please enter valid email' : ''}
        label='Email address'
        type='email'
      />
      <CustomButton
        onClick={validateUser}
        variant='contained'
        disabled={email && !invalid ? false : true}
        color={email && !invalid ? 'primary' : 'customDisable'}
        style={{ width: '50%', borderRadius: '14px', height: 56 }}
        textStyle={{
          color: email && !invalid ? zeplinColor.Neutral1 : zeplinColor.Neutral8,
        }}
        text={'Create Account'}
      />
    </div>
  );
  const alternative = (
    <div style={{ margin: '0px auto 0px', width: '50%' }}>
      <Link to={`https://${process.env.REACT_APP_M365}`} style={{ textDecoration: 'none' }}>
        <CustomButton
          disabled={false}
          variant='outlined'
          color='customSecondary'
          style={{
            color: zeplinColor.BasicBlack,
            width: '100%',
            margin: 'auto',
            borderRadius: '14px',
            height: 56,
            borderWidth: 1,
            borderColor: zeplinColor.Neutral9,
            display: 'flex',
            gap: '16px',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral5,
            },
          }}
          text={'Continue with Microsoft'}
          icon={<img src={'/assets/microsoft-logo.svg'} />}
          onClick={() => {}}
        />
      </Link>
    </div>
  );
  return (
    <EntryLayoutScreen
      header={'Create a huddle account'}
      subheader='Create your account using email address.'
      input={children}
      alternative={alternative}
      footerText='Already have an account? '
      footerButtonText='Log in'
      path={RoutePaths.Root}
      clickAction={() => {}}
      open={open}
      handleCloseModal={handleClose}
    />
  );
};

export default RegisterScreen;
